<template>
  <v-toolbar :color="color" :dark="dark" class="list-title">
    <v-toolbar-title>
      <slot name="title" />
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    /* Controls the color of the toolbar */
    color: {
      type: String,
      default: "light-blue"
    },
    /* Controls the dark mode of the toolbar */
    dark: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.list-title {
  width: calc(100% + 2px);
  margin-left: -1px;
}
</style>